"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.playeSettingProps = exports.default = void 0;

var _vue = require("vue");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _lodash = _interopRequireDefault(require("lodash"));

var _LeftOutlined = _interopRequireDefault(require("@ant-design/icons-vue/lib/icons/LeftOutlined"));

var _RightOutlined = _interopRequireDefault(require("@ant-design/icons-vue/lib/icons/RightOutlined"));

var _select = _interopRequireDefault(require("ant-design-vue/lib/select"));

require("ant-design-vue/lib/select/style/index.css");

var _slider = _interopRequireDefault(require("ant-design-vue/lib/slider"));

require("ant-design-vue/lib/slider/style/index.css");

var _switch = _interopRequireDefault(require("ant-design-vue/lib/switch"));

require("ant-design-vue/lib/switch/style/index.css");

var _dataMap = require("../utils/dataMap");

var _switchChecked = _interopRequireDefault(require("./assets/images/switch-checked.png"));

var _switchDisabled = _interopRequireDefault(require("./assets/images/switch-disabled.png"));

var _switchUncheck = _interopRequireDefault(require("./assets/images/switch-uncheck.png"));

var _SelectDowmList = _interopRequireDefault(require("./component/SelectDowmList"));

var playeSettingProps = {
  playParms: Object,
  playMode: {
    type: String,
    default: 'ori'
  },
  disabled: {
    type: Boolean,
    default: false
  },
  platform: {
    type: String
  }
};
exports.playeSettingProps = playeSettingProps;
var PlayeSetting = (0, _vue.defineComponent)({
  name: 'PlaySetting',
  components: {
    Switch: _switch.default,
    Select: _select.default,
    Slider: _slider.default,
    LeftOutlined: _LeftOutlined.default,
    RightOutlined: _RightOutlined.default,
    SelectDownList: _SelectDowmList.default
  },
  props: playeSettingProps,
  emits: ['update:playParms'],
  setup: function setup(props, ctx) {
    var handleTempoAndPitch = (0, _vue.inject)('handleTempoAndPitch');
    var playParms = (0, _vue.reactive)(props.playParms);
    var instrumentDisabled = (0, _vue.computed)(function () {
      return props.disabled || props.playMode !== 'midi';
    });
    (0, _vue.watch)(function () {
      return props.playParms;
    }, function (newVal) {
      // console.log('playParms prop playSetting', newVal);
      (0, _extends2.default)(playParms, newVal);
    });
    (0, _vue.watch)(function () {
      return playParms;
    }, function (newVal) {
      // console.log('playParms playSetting', newVal);
      ctx.emit('update:playParms', newVal);
    }, {
      deep: true
    });
    var isShowToolTip = (0, _vue.ref)(false);
    (0, _vue.watch)(function () {
      return isShowToolTip.value;
    }, function (newVal) {
      if (!newVal) {
        if (props.playMode === 'ori') {
          // @ts-ignore
          handleTempoAndPitch(props.playParms.oriFileBuffer, props.playParms.song.oriFileUrl, playParms.pitchSemitones, playParms.tempo).then().catch(function (e) {
            console.error(e);
          });
        } else if (props.playMode === 'acc') {
          // @ts-ignore
          handleTempoAndPitch(props.playParms.accFileBuffer, props.playParms.song.accFileUrl, playParms.pitchSemitones, playParms.tempo).then().catch(function (e) {
            console.error(e);
          });
        }
      }
    });

    var showToolTip = function showToolTip(flag) {
      if (props.disabled) {
        return;
      }

      isShowToolTip.value = !isShowToolTip.value; // 关闭蒙版时一起关闭这个弹窗

      if (flag === false) {
        isShowToolTip.value = false;
      }
    };

    (0, _vue.watch)(function () {
      return props.disabled;
    }, function (newVal) {
      newVal && (isShowToolTip.value = false);
    });
    var displayModes = (0, _vue.computed)(function () {
      return _dataMap.displayModeArray;
    });
    var keySignatures = (0, _vue.computed)(function () {
      var _a;

      return (0, _dataMap.getSourceKeySignaturesOptions)((_a = playParms === null || playParms === void 0 ? void 0 : playParms.sheetInfo) === null || _a === void 0 ? void 0 : _a.keySignature).map(function (item) {
        var _a;

        if (item.value === ((_a = playParms === null || playParms === void 0 ? void 0 : playParms.sheetInfo) === null || _a === void 0 ? void 0 : _a.keySignature)) {
          (0, _extends2.default)(item, {
            label: '原调'
          });
        }

        return item;
      });
    });
    var speeds = (0, _vue.computed)(function () {
      var cloneSpeeds = _lodash.default.cloneDeep(_dataMap.speeds);

      var hasSourceSpeed = cloneSpeeds.filter(function (i) {
        return i.value === (playParms === null || playParms === void 0 ? void 0 : playParms.sourceSpeed);
      }).length > 0;

      if (!hasSourceSpeed) {
        cloneSpeeds.unshift({
          label: '原速',
          value: playParms === null || playParms === void 0 ? void 0 : playParms.sourceSpeed
        });
      }

      var speeds = _lodash.default.uniqBy(cloneSpeeds, 'value').map(function (item) {
        if (item.value === (playParms === null || playParms === void 0 ? void 0 : playParms.sourceSpeed)) {
          (0, _extends2.default)(item, {
            label: '原速'
          });
        }

        return item;
      });

      return _lodash.default.orderBy(speeds, ['value'], ['asc']);
    });
    var soundfonts = (0, _vue.computed)(function () {
      return _dataMap.groupSoundFonts.reduce(function (pre, cur) {
        var sf = cur.data.map(function (item) {
          return (0, _extends2.default)((0, _extends2.default)({}, item), {
            group: cur.group
          });
        });
        pre.push.apply(pre, (0, _toConsumableArray2.default)(sf));
        return pre;
      }, []);
    });
    var keySignatureDisabled = (0, _vue.computed)(function () {
      return false;
    });
    var speedDisabled = (0, _vue.computed)(function () {
      return false;
    });
    var partInfoPageNum = (0, _vue.ref)(0);
    var partInfoGroup = (0, _vue.computed)(function () {
      var group = [];
      var parts = playParms.partInfo || [];

      for (var i = 0; i < parts.length; i += 4) {
        group.push(parts.slice(i, i + 4));
      }

      return group;
    });
    var pagePartInfo = (0, _vue.computed)(function () {
      if (partInfoGroup.value.length <= 0) {
        return [];
      }

      return partInfoGroup.value[partInfoPageNum.value];
    });

    var changePagePart = function changePagePart(type) {
      if (type === 'left' && partInfoPageNum.value >= 1) {
        // eslint-disable-next-line no-plusplus
        partInfoPageNum.value--;
      } else if (type === 'right' && partInfoPageNum.value + 1 < partInfoGroup.value.length) {
        // eslint-disable-next-line no-plusplus
        partInfoPageNum.value++;
      }
    };

    return {
      isShowToolTip: isShowToolTip,
      showToolTip: showToolTip,
      playParms: playParms,
      keySignatures: keySignatures,
      pagePartInfo: pagePartInfo,
      partInfoGroup: partInfoGroup,
      changePagePart: changePagePart,
      partInfoPageNum: partInfoPageNum,
      speeds: speeds,
      soundfonts: soundfonts,
      instrumentDisabled: instrumentDisabled,
      keySignatureDisabled: keySignatureDisabled,
      speedDisabled: speedDisabled,
      switchUncheck: _switchUncheck.default,
      switchChecked: _switchChecked.default,
      switchDisabled: _switchDisabled.default,
      displayModes: displayModes
    };
  },
  render: function render() {
    var _this = this;

    return (0, _vue.createVNode)("div", {
      "class": "play-setting"
    }, [(0, _vue.createVNode)("div", {
      "class": ['setting-btn', this.isShowToolTip ? 'setting-btn-active' : '', this.disabled ? 'setting-btn__disabled' : ''],
      "onClick": this.showToolTip
    }, [(0, _vue.createVNode)("p", null, [(0, _vue.createTextVNode)("\u64AD\u653E\u53C2\u6570")])]), this.isShowToolTip && (0, _vue.createVNode)("div", {
      "class": "setting-modal"
    }, [(0, _vue.createVNode)("div", {
      "class": "content-container"
    }, [(0, _vue.createVNode)("div", {
      "class": "content content-play-setting"
    }, [(0, _vue.createVNode)("div", {
      "class": "content_item"
    }, [(0, _vue.createVNode)(_SelectDowmList.default, {
      "class": "item-selector",
      "selectValue": _this.playParms.displayMode,
      "onUpdate:selectValue": function onUpdateSelectValue($event) {
        return _this.playParms.displayMode = $event;
      },
      "options": this.displayModes,
      "theme": "select",
      "popoverStyle": {
        height: '138px'
      }
    }, null)]), (0, _vue.createVNode)("div", {
      "class": "content_item"
    }, [(0, _vue.createVNode)("div", {
      "class": "content_item-text"
    }, [(0, _vue.createTextVNode)("\u8282\u62CD\u5668")]), this.playParms.isBeat ? (0, _vue.createVNode)("img", {
      "src": this.switchChecked,
      "onClick": function onClick() {
        return _this.playParms.isBeat = !_this.playParms.isBeat;
      }
    }, null) : (0, _vue.createVNode)("img", {
      "src": this.switchUncheck,
      "onClick": function onClick() {
        return _this.playParms.isBeat = !_this.playParms.isBeat;
      }
    }, null)]), (0, _vue.createVNode)("div", {
      "class": "content_item"
    }, [(0, _vue.createVNode)("div", {
      "class": "content_item-text"
    }, [(0, _vue.createTextVNode)("\u8282\u594F")]), this.playMode === 'ori' || this.playMode === 'acc' ? this.playParms.isRhythm ? (0, _vue.createVNode)("img", {
      "src": this.switchChecked,
      "onClick": function onClick() {
        return _this.playParms.isRhythm = !_this.playParms.isRhythm;
      }
    }, null) : (0, _vue.createVNode)("img", {
      "src": this.switchUncheck,
      "onClick": function onClick() {
        return _this.playParms.isRhythm = !_this.playParms.isRhythm;
      }
    }, null) : (0, _vue.createVNode)("img", {
      "src": this.switchDisabled
    }, null)]), (0, _vue.createVNode)("div", {
      "class": "content_item"
    }, [(0, _vue.createVNode)(_SelectDowmList.default, {
      "class": "item-selector",
      "selectValue": _this.playParms.speed,
      "onUpdate:selectValue": function onUpdateSelectValue($event) {
        return _this.playParms.speed = $event;
      },
      "options": this.speeds,
      "disabled": this.speedDisabled,
      "theme": "select",
      "popoverStyle": {
        height: '400px'
      }
    }, null)]), (0, _vue.createVNode)("div", {
      "class": "content_item"
    }, [(0, _vue.createVNode)(_SelectDowmList.default, {
      "class": "item-selector",
      "selectValue": _this.playParms.keySignature,
      "onUpdate:selectValue": function onUpdateSelectValue($event) {
        return _this.playParms.keySignature = $event;
      },
      "options": this.keySignatures,
      "disabled": this.keySignatureDisabled,
      "theme": "select",
      "popoverStyle": {
        height: '400px'
      }
    }, null)])]), (0, _vue.createVNode)("div", {
      "class": "content-line"
    }, null), (0, _vue.createVNode)("div", {
      "class": "content content-part-info"
    }, [this.playParms.partInfo.map(function (part, index) {
      return (0, _vue.createVNode)("div", {
        "class": "part-info",
        "key": part
      }, [(0, _vue.createVNode)("div", {
        "class": ['eye', part.show ? 'eye-open' : 'eye-close'],
        "onClick": function onClick() {
          !_this.disabled && (part.show = !part.show); // 特殊处理，因为关闭显示，对应声部的就要静音,mp3与演奏不做处理

          if (!part.show && _this.playMode !== 'ori' && _this.playMode !== 'acc' && _this.playMode !== 'midiNoVolume') {
            part.volume = 0;
          } else {
            part.volume = part.sourceVolume;
          }
        }
      }, null), (0, _vue.createVNode)("div", {
        "class": 'volume'
      }, [part.showName, (0, _vue.createTextVNode)("\u97F3\u91CF"), (0, _vue.createVNode)(_slider.default, {
        "value": part.volume,
        "onUpdate:value": function onUpdateValue($event) {
          return part.volume = $event;
        },
        "tooltipVisible": false,
        "onChange": function onChange(val) {
          return part.sourceVolume = val;
        },
        "min": 0,
        "max": 1,
        "step": 0.01,
        "disabled": _this.disabled || _this.playMode === 'ori' || _this.playMode === 'acc' || _this.playMode === 'midiNoVolume',
        "class": ['slider', _this.disabled || _this.playMode === 'ori' || _this.playMode === 'acc' || _this.playMode === 'midiNoVolume' ? 'slider__disabled' : '']
      }, null)]), (0, _vue.createVNode)(_SelectDowmList.default, {
        "class": "item-selector",
        "key": index,
        "selectValue": part.instrument,
        "onUpdate:selectValue": function onUpdateSelectValue($event) {
          return part.instrument = $event;
        },
        "options": _this.soundfonts,
        "theme": "select",
        "sameWidth": false,
        "popoverStyle": {
          width: '300px',
          height: '500px'
        },
        "group": true,
        "disabled": _this.instrumentDisabled
      }, null)]);
    })]), (0, _vue.createVNode)("div", {
      "class": "content-line"
    }, null), (0, _vue.createVNode)("div", {
      "class": "content content-sheet-operation"
    }, [(0, _vue.createVNode)("div", {
      "class": "content-sheet-operation_item"
    }, [(0, _vue.createVNode)("div", {
      "class": [this.playParms.colvin ? 'colvin-btn-active' : '', !this.playParms.colvin ? 'colvin-btn' : ''],
      "onClick": function onClick() {
        _this.playParms.colvin = !_this.playParms.colvin;
      }
    }, null)]), (0, _vue.createVNode)("div", {
      "class": "content-sheet-operation_item"
    }, [(0, _vue.createVNode)("div", {
      "class": [this.playParms.meodly ? 'meodly-btn-active' : '', !this.playParms.meodly ? 'meodly-btn' : ''],
      "onClick": function onClick() {
        _this.playParms.meodly = !_this.playParms.meodly;
      }
    }, null)]), (0, _vue.createVNode)("div", {
      "class": "content-sheet-operation_item"
    }, [(0, _vue.createVNode)("div", {
      "class": [this.playParms.isPreReadyTime ? 'preready-time-btn-active' : '', !this.playParms.isPreReadyTime ? 'preready-time-btn' : ''],
      "onClick": function onClick() {
        _this.playParms.isPreReadyTime = !_this.playParms.isPreReadyTime;
      }
    }, null)]), (0, _vue.createVNode)("div", {
      "class": "content-sheet-operation_item"
    }, [(0, _vue.createVNode)("div", {
      "class": [this.playParms.showLyrics ? 'show-lyrics-btn-active' : '', !this.playParms.showLyrics ? 'show-lyrics-btn' : ''],
      "onClick": function onClick() {
        _this.playParms.showLyrics = !_this.playParms.showLyrics;
      }
    }, null)]), (0, _vue.createVNode)("div", {
      "class": "content-sheet-operation_item"
    }, [(0, _vue.createVNode)("div", {
      "class": [this.playParms.showMetronomeSignature ? 'show-metronome-signature-btn-active' : '', !this.playParms.showMetronomeSignature ? 'show-metronome-signature-btn' : ''],
      "onClick": function onClick() {
        _this.playParms.showMetronomeSignature = !_this.playParms.showMetronomeSignature;
      }
    }, null)]), (0, _vue.createVNode)("div", {
      "class": "content-sheet-operation_item"
    }, [(0, _vue.createVNode)("div", {
      "class": [this.playParms.rollCall ? 'roll-call-btn-active' : '', !this.playParms.rollCall ? 'roll-call-btn' : ''],
      "onClick": function onClick() {
        _this.playParms.rollCall = !_this.playParms.rollCall;
      }
    }, null)]), (0, _vue.createVNode)("div", {
      "class": "content-sheet-operation_item"
    }, [(0, _vue.createVNode)("div", {
      "class": [this.playParms.fullSheet ? 'full-sheet-btn-active' : '', !this.playParms.fullSheet ? 'full-sheet-btn' : ''],
      "onClick": function onClick() {
        _this.playParms.fullSheet = !_this.playParms.fullSheet;
      }
    }, null)])])]), (0, _vue.createVNode)("div", {
      "class": "close-tool-tip",
      "onClick": this.showToolTip
    }, null)])]);
  }
});

PlayeSetting.install = function (app) {
  app.component(PlayeSetting.name, PlayeSetting);
  return app;
};

var _default = PlayeSetting;
exports.default = _default;